import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <FeaturesSection />
        <CommentsSection />
        <ContactSection />
        <AboutSection />
        <FaqSection />
        <CarouselSection />
        <RankingSection />
        <IndexSection />
        <CardsSection />
        <MediaSection />
        <UpdatesSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}